<template>
    <div class="main-body">
        <h2>Address Book</h2>
        <div class="action-bar">
            <div>
                <el-button type="primary" size="small" @click="onCreate">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter">
                <el-form v-model="filter" :inline="true">
                    <el-form-item>
                        <el-input v-model="filter.group_name" size="small" class="max-width-120"
                                  :placeholder="$strings('word/address_name')" clearable/>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" @click="onSearch">Search</el-button>
                        <el-button size="small" @click="onReset">Reset</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="table-wrapper">
            <el-table :data="tableData" v-loading="tableLoading" border>
                <el-table-column prop="group_id" :label="$strings('word/address_id')"></el-table-column>
                <el-table-column prop="group_name" :label="$strings('word/address_name')"></el-table-column>
                <el-table-column prop="cnt" :label="$strings('word/count')"></el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column :label="$strings('word/edit')" width="254">
                    <template slot-scope="scope">
                        <el-button size="small" @click="onEdit(scope.row)">{{ $strings('word/edit') }}</el-button>
                        <el-button size="small" @click="onEnter(scope.row)">{{ $strings('word/numbers') }} ></el-button>
                        <el-popconfirm :title="$strings('word/drop_this_item')" @confirm="onDrop(scope.row)">
                            <el-button size="small" slot="reference" style="margin-left: 10px;">
                                {{ $strings('word/delete') }}
                            </el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination" v-if="pagination.total > pagination.size" style="text-align: right">
            <el-pagination background layout="prev, pager, next" :total="pagination.total"
                           :page-size.sync="pagination.size"
                           :current-page.sync="pagination.page" @current-change="changePage"></el-pagination>
        </div>
        <el-dialog
            :title="isEdit ? $strings('word/edit') : $strings('word/create')"
            :visible.sync="showDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="row" label-width="80px" :rules="rules">
                    <el-form-item :label="$strings('word/name')" prop="group_name">
                        <el-input v-model="row.group_name" clearable maxlength="24" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSave()" :loading="saving">{{ $strings('word/confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {CpSiteAddressCreate, CpSiteAddressRead, CpSiteAddressUpdate} from "@/api/cpsite/api";
import {UnixToDateFull} from "@/utils/time";
import {GetItem} from "@/utils/storage";
import {API_STATUS_CODE, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import {CpSiteAddressDrop} from "../../../api/cpsite/api";

export default {
    name: "cpsite-address",
    data() {
        return {
            filter: {group_name: ''},
            pagination: {total: 0, size: 10, page: 1},
            tableLoading: true,
            tableData: [],
            isEdit: true,
            row: {},
            showDialog: false,
            dropVisible: false,
            saving: false,
            rules: {
                group_name: [
                    {required: true, message: this.$strings('cpsite/app/error/field_empty'), trigger: 'blur'}
                ],
            },
        }
    },
    created() {
        this.fetchTableData()
    },
    methods: {
        onCreate() {
            this.isEdit = false;
            this.row = {};
            this.showDialog = true;
        },
        onEdit(row) {
            this.isEdit = true;
            this.row = JSON.parse(JSON.stringify(row));
            this.showDialog = true;
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onSave() {
            this.saving = true;
            let action = this.isEdit ? CpSiteAddressUpdate : CpSiteAddressCreate;
            action(this.row).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.showDialog = false;
                    this.fetchTableData();
                }
            });
        },
        onDrop(row) {
            CpSiteAddressDrop(row).then(() => {
                this.$notify.success({
                    title: 'SUCCESS',
                    message: 'delete address successfully'
                })
                this.fetchTableData();
            });
        },
        onSearch() {
            this.fetchTableData();
        },
        onReset() {
            this.filter.group_name = '';
            this.fetchTableData();
        },
        onEnter(row) {
            this.$router.push('/cpsite/address-items/' + row.group_id + '/' + row.group_name);
        },
        changePage() {
            console.log('page.change', this.pagination);
            this.fetchTableData();
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        fetchTableData() {
            this.tableLoading = true;
            this.filter.size = this.pagination.size;
            this.filter.page = this.pagination.page;
            CpSiteAddressRead(this.filter).then((resp) => {
                if (resp.data.data.count === 0) {
                    this.tableData = [];
                    this.pagination.total = 0;
                } else {
                    this.pagination.total = resp.data.data.count;
                    this.tableData = resp.data.data.rows;
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;

    .filter {
        flex-grow: 1;
        text-align: right;
    }
}

.pagination {
    margin-top: 1em;
}

.table-wrapper {
    margin-top: 1em;
}
</style>